export default function ($q, SolrSearch, SolrSearchSecure, ParserService) {
    'ngInject';

    return function () {
        this.getSolrResults = function (searchTerm, core, cursor, maxResults, filter, secure) {
            var basicPromise = $q.defer();
            generateSolrResults(searchTerm, core, cursor, maxResults, filter, secure).then(
                function(result) {
                    basicPromise.resolve(ParserService.parseSolrData(result));
                },
                function(result) {
                    basicPromise.reject(result);
                }
            )
            return basicPromise.promise;
        }
        
        function generateSolrResults(searchTerm, core, cursor, maxResults, filter, secure) {
            if (secure) {
                return SolrSearchSecure.get({
                        core: core,
                        q: searchTerm,
                        c: cursor,
                        r: maxResults,
                        f: filter
                    }).$promise;
            }
            else {
                return SolrSearch.get({
                        core: core,
                        q: searchTerm,
                        c: cursor,
                        r: maxResults,
                        f: filter
                    }).$promise;
            }
        }        
    }
}



// WEBPACK FOOTER //
// ./src/search-interface/shared/services/searchService.js